var map = {
	"./alan.png": "d792",
	"./bishop.png": "bfe5",
	"./bowmaster.png": "0b4e",
	"./captain.png": "8cef",
	"./crossbowmaster.png": "6cf4",
	"./darknight.png": "f117",
	"./framewizard.png": "8385",
	"./hero.png": "528a",
	"./ice.png": "ffe2",
	"./nightload.png": "472b",
	"./nightwalker.png": "1de8",
	"./no.png": "7d61",
	"./paladin.png": "3344",
	"./shadow.png": "1266",
	"./soulmaster.png": "c847",
	"./striker.png": "c2a4",
	"./viper.png": "496b",
	"./windshooter.png": "753a"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) { // check for number or string
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return id;
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "2ead";